var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96415e-07 15C6.86326e-07 16.0285 0.389357 17.057 1.16807 17.8331L12.4789 28.8745C14.0363 30.3881 16.5282 30.3687 18.0467 28.8163C19.5652 27.2639 19.5457 24.7801 17.9883 23.2665L13.5496 18.9198L26.0675 18.9198C28.2479 18.9198 30 17.154 30 15C30 12.8461 28.2284 11.0802 26.0675 11.0802L13.5496 11.0802L17.9883 6.73353C19.5457 5.21995 19.5652 2.73612 18.0467 1.18373C16.5282 -0.368668 14.0363 -0.388072 12.4789 1.12551L1.18754 12.1669C0.389357 12.9431 5.06504e-07 13.9716 0.0194689 15L5.96415e-07 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9a10526b7a39f0c030787ee711896699.svg";
export { ForwardRef as ReactComponent };